import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';
import { Role } from '../enums/role';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.checkUserRole(state.url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.checkUserRole(state.url);
  }

  private checkUserRole(url: string): Observable<boolean | UrlTree> {
    const currentUser = this.authService.currentUser$();

    // Cas 1: utilisateur déjà chargé
    if (currentUser) {
      return of(this.getRedirectUrl(currentUser.role, url));
    }

    // Cas 2: chargement du profil utilisateur
    return this.authService.loadUserProfile().pipe(
      map((user) => this.getRedirectUrl(user.role, url)),
      catchError(() => {
        this.authService.logout();
        return of(this.router.parseUrl('/login'));
      }),
    );
  }

  private getRedirectUrl(role: string, url: string): boolean | UrlTree {
    const firstSegment = url.split('/')[1];
    const lastSegment = url.split('/')[2];
    if (role === Role.admin) {
      return firstSegment === 'admin' ? true : this.router.parseUrl('/admin');
    } else if (role === Role.assessmentManager) {
      return firstSegment === 'apps' && lastSegment !== 'users'
        ? true
        : this.router.parseUrl('/apps/dashboard');
    } else {
      return firstSegment === 'apps' ? true : this.router.parseUrl('/apps/dashboard');
    }
  }
}
